"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var enquiryFormDataTransformer = {
    to: function (data) {
        var _a, _b, _c;
        var formData = {
            nameInfo: {
                firstName: data.firstName || '',
                lastName: data.lastName || '',
                salutation: data.salutation || 1,
            },
            contactInfo: {
                phone: data.phone || '',
                email: data.email || '',
                areaCode: data.areaCode || '',
            },
            location: {
                city: data.city || '',
                dealer: data.dealer || '',
                postcode: data.postcode || '',
                userId: data.identificationNumber || '',
            },
            termsAndConditions: (_a = data.termsAndConditions, (_a !== null && _a !== void 0 ? _a : false)),
            marketingInformation: (_b = data.marketingInformation, (_b !== null && _b !== void 0 ? _b : false)),
            captchaToken: data.captchaToken,
            appointment: {
                dealer: data.dealerAppointment || '',
                preferredDate: data.preferredDate || '',
                preferredTime: data.preferredTime || '',
                comments: data.comments || '',
                preferredConsultant: (_c = data.preferredConsultant, (_c !== null && _c !== void 0 ? _c : '')),
            },
            housing: {
                housingDepartment: data.housingDepartment || '',
                housingRegion: data.housingRegion || '',
                housingProvince: data.housingProvince || '',
                housingDistrict: data.housingDistrict || '',
                housingStreet: data.housingStreet || '',
            },
        };
        if (data.district) {
            formData.location.district = data.district;
        }
        if (data.identificationNumber) {
            formData.identificationNumber = {
                userId: data.identificationNumber || '',
                userIdType: data.identificationType || '',
            };
        }
        return formData;
    },
    from: function (data) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
        var formData = {
            firstName: (_a = data.nameInfo) === null || _a === void 0 ? void 0 : _a.firstName,
            lastName: (_b = data.nameInfo) === null || _b === void 0 ? void 0 : _b.lastName,
            phone: (_c = data.contactInfo) === null || _c === void 0 ? void 0 : _c.phone,
            email: (_d = data.contactInfo) === null || _d === void 0 ? void 0 : _d.email,
            dealer: ((_e = data.appointment) === null || _e === void 0 ? void 0 : _e.dealer) || ((_f = data.location) === null || _f === void 0 ? void 0 : _f.dealer),
            termsAndConditions: data.termsAndConditions,
            captchaToken: data.captchaToken,
        };
        if ((_g = data.appointment) === null || _g === void 0 ? void 0 : _g.preferredDate) {
            formData.preferredDate = data.appointment.preferredDate;
        }
        if ((_h = data.appointment) === null || _h === void 0 ? void 0 : _h.preferredTime) {
            formData.preferredTime = data.appointment.preferredTime;
        }
        if ((_j = data.appointment) === null || _j === void 0 ? void 0 : _j.comments) {
            formData.comments = data.appointment.comments;
        }
        if ((_k = data.appointment) === null || _k === void 0 ? void 0 : _k.preferredConsultant) {
            formData.preferredConsultant = data.appointment.preferredConsultant;
        }
        if ((_l = data.nameInfo) === null || _l === void 0 ? void 0 : _l.salutation) {
            formData.salutation = data.nameInfo.salutation;
        }
        if ((_m = data.contactInfo) === null || _m === void 0 ? void 0 : _m.areaCode) {
            formData.areaCode = data.contactInfo.areaCode;
        }
        if ((_o = data.location) === null || _o === void 0 ? void 0 : _o.city) {
            formData.city = data.location.city;
        }
        if ((_p = data.location) === null || _p === void 0 ? void 0 : _p.district) {
            formData.district = data.location.district;
        }
        if ((_q = data.location) === null || _q === void 0 ? void 0 : _q.postcode) {
            formData.postcode = data.location.postcode;
        }
        if ((_r = data.location) === null || _r === void 0 ? void 0 : _r.userId) {
            formData.userId = data.location.userId;
        }
        if (((_s = data.identificationNumber) === null || _s === void 0 ? void 0 : _s.userId) !== undefined) {
            formData.userId = ((_t = data.location) === null || _t === void 0 ? void 0 : _t.userId) || data.identificationNumber.userId;
        }
        if ((_u = data.identificationNumber) === null || _u === void 0 ? void 0 : _u.userIdType) {
            formData.identificationType = data.identificationNumber.userIdType;
        }
        if (data.marketingInformation) {
            formData.marketingInformation = data.marketingInformation;
        }
        if (data.housing) {
            formData.housingDepartment = data.housing.housingDepartment || '';
            formData.housingRegion = data.housing.housingRegion || '';
            formData.housingProvince = data.housing.housingProvince || '';
            formData.housingDistrict = data.housing.housingDistrict || '';
            formData.housingStreet = data.housing.housingStreet || '';
        }
        return formData;
    },
};
exports.default = enquiryFormDataTransformer;
